module.exports = __webpack_public_path__ + "spotlight2.50625ca011f325084e320965f61baab0.png";